import { render } from "./OrderHistoryPage.vue?vue&type=template&id=002fd953&scoped=true&ts=true"
import script from "./OrderHistoryPage.vue?vue&type=script&lang=ts"
export * from "./OrderHistoryPage.vue?vue&type=script&lang=ts"

import "./OrderHistoryPage.vue?vue&type=style&index=0&id=002fd953&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002fd953"]])

export default __exports__